import { RecentReportsResult, Report } from './models';
import { Nullable } from 'common';

export const SET_RECENT_REPORTS_LOADING = 'SET_RECENT_REPORTS_LOADING';
export const GET_RECENT_REPORTS_SUCCESS = 'GET_RECENT_REPORTS_SUCCESS';

export interface RecentReportsState {
  recentReports: Nullable<RecentReportsResult>;
  loading: boolean;
}

export interface SetRecentReportsLoadingType {
  type: typeof SET_RECENT_REPORTS_LOADING;
  loading: boolean;
}

export interface GetRecentReportsSuccessType {
  type: typeof GET_RECENT_REPORTS_SUCCESS;
  recentReports: RecentReportsResult;
}

export type RecentReportsDOMType = Report & {
  date: string;
  time: string;
};

export type RecentReportsTypes =
  | SetRecentReportsLoadingType
  | GetRecentReportsSuccessType;
